import { css, type Theme } from "@emotion/react";

/*
 * Method referenced from Tommy Brunn on dev.to:
 * https://dev.to/nevon/detecting-autofilled-fields-in-javascript-l46
 */

export const autoFillDetector = (theme: Theme) => css`
  @keyframes onAutoFillStart {
    from {
      /**/
    }
    to {
      /**/
    }
  }

  @keyframes onAutoFillCancel {
    from {
      /**/
    }
    to {
      /**/
    }
  }

  &:-webkit-autofill {
    // Expose a hook for JavaScript when auto fill is shown.
    // JavaScript can capture 'animationstart' events
    animation-name: onAutoFillStart;
    font-family: ${theme.aviaryTypography.body.fontFamily};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: ${theme.system.textBase} !important;
    -webkit-box-shadow: 0 0 0 1000px ${theme.surface.level0} inset !important;
    box-shadow: 0 0 0 1000px ${theme.surface.level0} inset !important;
    background-clip: content-box !important;
    caret-color: ${theme.system.textBase};
    transition: background-color 5000000s ease-in-out 0s;
  }

  &:not(:-webkit-autofill) {
    // Expose a hook for JS onAutoFillCancel
    // JavaScript can capture 'animationstart' events
    animation-name: onAutoFillCancel;
  }
`;
